<mat-label class="subHeading">Fuel Type<span *ngIf="isRequired" class="star">*</span></mat-label>
<mat-select multiple formControlName="fuel_type" class="fuel" placeholder="{{isRequired ? 'Select' : 'All'}}">
    <mat-option (onSelectionChange)="selectionChange($event)" *ngFor="let fuelType of fuelTypes" [value]="fuelType">{{fuelType | titlecase}}</mat-option>
</mat-select>